// App
import { fetchEntityWorkaround } from 'state/dashboards/experiment-dashboard/fetch-entity-workaround';
import actionTypes from 'state/actionTypes';
import { makeExperimentIdentifier } from 'common/experiment';

// Module
export function fetchExperimentDetails(organizationName, projectName, shortId) {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.EXPERIMENT_DETAILS_FETCH,
      payload: {
        organizationName,
        projectName,
        shortId,
      },
    });

    const experimentId = makeExperimentIdentifier(organizationName, projectName, shortId);

    try {
      const entity = await fetchEntityWorkaround(organizationName, projectName, shortId);

      dispatch(fetchExperimentDetailsSuccess(entity));
    } catch (errorResponse) {
      dispatch(fetchExperimentDetailsFail(errorResponse, experimentId));
    }
  };
}

function fetchExperimentDetailsSuccess(experiment) {
  return {
    type: actionTypes.EXPERIMENT_DETAILS_FETCH_SUCCESS,
    payload: {
      experiment,
    },
  };
}

function fetchExperimentDetailsFail(error, experimentId) {
  return {
    type: actionTypes.EXPERIMENT_DETAILS_FETCH_FAIL,
    payload: {
      error,
      experimentId,
    },
  };
}

export function startEditingChart(chartId) {
  return {
    type: actionTypes.CHARTS_START_EDITING_CHART,
    payload: { chartId },
  };
}

export function stopEditingChart(chartId) {
  return {
    type: actionTypes.CHARTS_STOP_EDITING_CHART,
    payload: { chartId },
  };
}
